// extracted by mini-css-extract-plugin
module.exports = {"strokeMarketplaceColor":"IconFlags_strokeMarketplaceColor__1l_wV"};